import React from "react";

// R4 PR 1: app-wide safety net. A render error anywhere in the routed content
// used to unmount the whole tree and leave a blank white page. Now the user
// gets a plain card with Reload and Back to dashboard. The error is logged to
// the console only; its text and stack are never shown to the user.
// App.js keys this on location.pathname, so navigating away clears the error.
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("AppErrorBoundary caught an error", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    // silent: a failed chunk in a floating widget must not replace the page.
    if (this.props.silent) return null;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" role="alert">
        <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-slate-900">
            Something went wrong loading this page.
          </h1>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
            >
              Reload
            </button>
            <a
              href="/dashboard"
              className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            >
              Back to dashboard
            </a>
          </div>
        </div>
      </div>
    );
  }
}
